import { changeTone } from '../browseFormat';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseRows.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The colour class of a 7-day change: green up, red down, grey for none. */
export function changeToneClass(value: number | null | undefined): string | undefined {
  const tone = changeTone(value);
  if (tone === 'up') {
    return styles.up;
  }
  return tone === 'down' ? styles.down : styles.flat;
}
